import { errors } from 'redux-rest-reducer';
import { ACTIONS } from 'actions/slot-popup';
import { ACTIONS as logoutActions } from 'actions/logout';

const initialState = null;

export default function (state = initialState, { type, payload }) {
  switch (type) {
    
    case ACTIONS.UPDATE_SLOT_POPUP_OPENED: {
      return payload;
    }
    case ACTIONS.INVALIDATE_SLOT_POPUP_OPENED:
    case logoutActions.POST_SUCCESS:
    case errors[401]:
      return initialState;
    default:
      return state;
  }
}
